import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

interface StepNavigationProps {
  currentStep: number;
  onPrevious?: () => void;
  onNext?: () => void;
  canGoPrevious?: boolean;
  canGoNext?: boolean;
  nextLabel?: string;
  previousLabel?: string;
  loading?: boolean;
}

export default function StepNavigation({
  currentStep,
  onPrevious,
  onNext,
  canGoPrevious = true,
  canGoNext = true,
  nextLabel = 'Continuar',
  previousLabel = 'Voltar',
  loading = false
}: StepNavigationProps) {
  return (
    <div className="flex flex-col md:flex-row justify-between items-center mt-8 gap-4 md:gap-0">
      {/* Indicador de progresso (Mobile: Link 1 / Desktop: Center) */}
      <div className="flex items-center space-x-2 order-1 md:order-2 mb-2 md:mb-0">
        {[1, 2, 3].map((step) => (
          <div
            key={step}
            className={`w-3 h-3 rounded-full ${step === currentStep
              ? 'bg-green-600'
              : step < currentStep
                ? 'bg-green-400'
                : 'bg-gray-300'
              }`}
          />
        ))}
        <span className="ml-3 text-sm text-gray-600">
          Passo {currentStep} de 3
        </span>
      </div>

      {/* Botão Avançar/Continuar (Mobile: Line 2 / Desktop: Right) */}
      <button
        onClick={onNext}
        disabled={!canGoNext || loading}
        className="w-full md:w-auto flex justify-center items-center px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-500 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-green-600 transition-colors order-2 md:order-3"
      >
        {loading && (
          <svg className="animate-spin h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        )}
        {nextLabel}
        {!loading && <ChevronRightIcon className="w-5 h-5 ml-2" />}
      </button>

      {/* Botão Voltar (Mobile: Line 3 / Desktop: Left) */}
      <button
        onClick={onPrevious}
        disabled={!canGoPrevious || currentStep === 1}
        className="w-full md:w-auto flex justify-center items-center px-6 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white transition-colors order-3 md:order-1"
      >
        <ChevronLeftIcon className="w-5 h-5 mr-2" />
        {previousLabel}
      </button>
    </div>
  );
}


